"use strict";
/**
 * 获取数据
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getData = void 0;
var cookie_1 = __importDefault(require("../cookie"));
var jsonp_1 = __importDefault(require("../jsonp"));
function getData(callback) {
    var domain = self.location.hostname;
    var uid = '';
    var uidal = cookie_1["default"].get('uidal');
    if (uidal && uidal.length >= 16) {
        uid = uidal.substring(0, 16);
    }
    var config = {
        client: "web",
        timestamp: (new Date()).getTime().toString(),
        args: {
            uid: uid,
            posCode: "downloadapp",
            domain: domain //"edcp.eastmoney.com" //eastmoney.com edcp.eastmoney.com quotation.eastmoney.com  edcp.eastmoney.com
            // domain: 'quotation.eastmoney.com' //"edcp.eastmoney.com" //eastmoney.com edcp.eastmoney.com quotation.eastmoney.com  edcp.eastmoney.com
        }
    };
    // let api_url = 'https://eminterservice-test.eastmoney.com/api/data/adInfo'
    var api_url = 'https://eminterservice.eastmoney.com/api/data/adInfo';
    (0, jsonp_1["default"])("".concat(api_url, "?data=").concat(encodeURIComponent(JSON.stringify(config))), callback, {
        prefix: 'websitepoptg_jp',
        param: 'cb'
    });
}
exports.getData = getData;
